module.exports = __webpack_public_path__ + "media/src/ShoppingCart/images/line_icon/insurance_40px_blue-1d79879ede4860788cd4f05b6efc880f.svg";